import EventEmitter from "events";

const UpdateFavoriteVODObserver = new EventEmitter();

export default UpdateFavoriteVODObserver;



// WEBPACK FOOTER //
// ./src/AAFPlayer/helpers/UpdateFavoriteVODObserver.js